import { useState } from 'react'
import { useMachineryApiClient } from '@/api/machinery/useMachineryApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadMachineryExcel = () => {
  const repository = useMachineryApiClient()
  const query = useDownloadExcelFile<void>({
    filename : 'maquinarias.xlsx',
    callable : repository.downloadExcelResume,
    messages : {
      default : 'Error al generar archivo',
      loading : 'Generando archivo',
      success : 'Archivo generado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async () => {
    const response = await query.submit()
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
